<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Estate Agent Details</h5>
  <div class="d-flex align-items-center gap-2  ms-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openAuditForForm()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" *ngIf="!generatingLetters" (click)="close()"></button>
  </div>
</div>

<div class="modal-body">
  <form [formGroup]="estateAgentDetails" autocomplete="off">

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Financial Advisor/Estate Agent Name</label>
        <select class="form-select" formControlName="addedByUserId" (change)="updateField()"
          [attr.disabled]="(!authService.isPortalManager() && !authService.isPortalAdmin()) ? true : null">
          <option *ngFor="let user of faUsers" [value]="user.id">{{user.firstName}} {{user.lastName}}</option>
        </select>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Estate Agent Company</label>
        <div class="form-control-plaintext">{{estateAgentDetails.controls['userCompanyName'].value}}</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Estate Agent Contact Number</label>
        <input class="form-control" formControlName="contactNumber" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Estate Agent Email Address</label>
        <div class="form-control-plaintext">{{estateAgentDetails.controls['addedByUser'].value?.emailAddress}}</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Estate Agent Fee</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="estateAgentFee" (change)="updateField()" type="number">
        </div>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Estate Agent Postcode</label>
        <div class="input-group">
          <input class="form-control" #estateAgentPostcode maxlength="10"
            formControlName="estateAgentPostcode" (change)="updateField()">
          <app-address-lookup-button [for]="addressLookup1"></app-address-lookup-button>
        </div>
      </div>
    </div>

    <app-address-lookup #addressLookup1 lookupType="postcode"
      [searchField]="estateAgentPostcode"
      [add1]="estateAgentDetails.controls['estateAgentAddressLine1']"
      [add2]="estateAgentDetails.controls['estateAgentAddressLine2']"
      [add3]="estateAgentDetails.controls['estateAgentAddressLine3']"
      [add4]="estateAgentDetails.controls['estateAgentAddressLine4']"
      [add5]="estateAgentDetails.controls['estateAgentAddressLine5']"
      [addPc]="estateAgentDetails.controls['estateAgentPostcode']"
      (change)="updateField()">
    </app-address-lookup>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 1</label>
        <input class="form-control" maxlength="100" formControlName="estateAgentAddressLine1" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 2</label>
        <input class="form-control" maxlength="100" formControlName="estateAgentAddressLine2" (change)="updateField()">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 3</label>
        <input class="form-control" maxlength="100" formControlName="estateAgentAddressLine3" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 4</label>
        <input class="form-control" maxlength="100" formControlName="estateAgentAddressLine4" (change)="updateField()">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 5</label>
        <input class="form-control" maxlength="100" formControlName="estateAgentAddressLine5" (change)="updateField()">
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button *ngIf="!generatingLetters" type="button" class="btn btn-success" (click)="createLetters()">
    Create Draft Contract Documents
  </button>
  <button *ngIf="generatingLetters" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Generating...
  </button>
</div>